export const BACKEND_URL = 'https://apps.ilsp.gr:5004';
export const WEBSOCKET_URL = 'wss://apps.ilsp.gr:5004';
export const VERSION = 2;
